import { LoginResponse } from '../interfaces/auth.interface';

/** key ของ session ใน localStorage — ใช้ร่วมกันระหว่าง AuthService และ SSO (sso.ts ทำงานก่อน Angular เริ่ม) */
export const AUTH_KEYS = {
    token: 'bo.token',
    expire: 'bo.expires_at',
    user: 'bo.user',
} as const;

export function saveSession(data: LoginResponse['data']) {
    localStorage.setItem(AUTH_KEYS.token, data.token);
    localStorage.setItem(AUTH_KEYS.expire, data.expires_at);
    localStorage.setItem(AUTH_KEYS.user, JSON.stringify(data.user));
}

export function clearSession() {
    localStorage.removeItem(AUTH_KEYS.token);
    localStorage.removeItem(AUTH_KEYS.expire);
    localStorage.removeItem(AUTH_KEYS.user);
}
